// doc(arm) - https://stackoverflow.com/questions/70811987/using-renderoption-in-muis-autocomplete

import * as React from "react";
import { hubsupportalApi } from 'app/utils/utils';

import {
  Autocomplete,
  CircularProgress,
  styled,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
  Box
} from '@mui/material';

import { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import OfficeDialog from './Office.tsx';

const AutoComplete = styled(Autocomplete)(() => ({ width: 350, paddingTop: 7 }));

const StyledFormControl = styled(FormControl)(() => ({
  minWidth: 120,
  marginBottom: 16
}));

export const fetchPatientByUid = async (patient_uid, environment) => {
  const response = await hubsupportalApi.get(
    `get_core_patient?patient_uid=${patient_uid}&env=${environment}&options=get_companions`, 
    { cache_timeout: 3600 }
  );
  console.log('onInputEnter: 2a', response);

  const patient = response.data.data;
  console.log(patient);

  // Some backend error cases still return { status: "success" } but include an error payload.
  // Do not treat those as a valid patient selection (it can accidentally clear the UI state
  // by setting patient_uid="").
  if (response.data.status == "success" && !patient?.error && patient?.metadata?.uid) {
    patient.environment = environment;

    const patient_uid = patient.metadata?.uid || '';
    const name = patient.spec?.name || '';
    const surname = patient.spec?.surname || '';
    const officeName = patient.office_name || '';
    const patientOptions = [{
      environment: environment,
      patient_uid: patient_uid,
      name: `${name} ${surname}`,
      office: `${officeName}`,
      data_get: patient,
      devices: [
        ...(patient?.extra?.devicehubs || []),
        ...(patient?.extra?.devices || [])
      ],
    }];

    return patientOptions[0];
  }

  return null;
}

export const fetchPatientData = async (patient, environment) => {
  console.log("onChangePatient::", patient);
  const response = await hubsupportalApi.get(
    "get_core_patient?patient_uid=" + patient.patient_uid + "&env=" + environment + "&options=get_companions", 
    { cache_timeout: 3600 });
  console.log('onChange::get_core_patient:', response);
  console.log('onChange::get_core_patient:', response.data);

  if (response.data.status === "success" && !response.data.data?.error) {
    let get_patient = response.data.data;
    console.log("onChange::get_patient", get_patient);

    patient.data_get = get_patient;
    const name = get_patient.spec?.name || '';
    const surname = get_patient.spec?.surname || '';
    const officeName = get_patient.office_name || '';
    patient.name = `${name} ${surname}`;
    patient.office = `${officeName}`;
    patient.data_get = get_patient;
    patient.devices = [
      ...(get_patient?.extra?.devicehubs || []),
      ...(get_patient?.extra?.devices || [])
    ];

    const response2 = await hubsupportalApi.get("get_core_device_accounts?patient_uid=" + patient.patient_uid + "&env=" + environment, { cache_timeout: 3600 });
    console.log('onChange::get_core_device_accounts:', response2);

    if (response.data.status === "success") {
      const device_accounts = response2.data.data?.items;
      console.log("onChange::get_core_device_accounts", device_accounts);

      patient.device_accounts = device_accounts;
      device_accounts.forEach(account => {
        if (account.spec && account.spec.class === 'app') {
          patient.watch_da = account;
          patient.watch_da_data = account.spec.devices[0];
        }
      });

      return patient;
    }
  }

  return null;
};

const PatientSelector = ({
  className,
  patient,
  onChangePatient,
  clearNameField,
  setClearNameField,
  environment,
  inputValue,
  setInputValue,
  setEnvironment,
  settingsOpen: settingsOpenProp,
  setSettingsOpen: setSettingsOpenProp,
}) => {

  const [open, setOpen] = useState(false);
  const [settingsOpenLocal, setSettingsOpenLocal] = useState(false);
  const settingsOpen = settingsOpenProp ?? settingsOpenLocal;
  const setSettingsOpen = setSettingsOpenProp ?? setSettingsOpenLocal;
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState(null); // Will store {name: string, uid: string}
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  //const loading = open && options.length === 0;
  //const [inputValue, setInputValue] = useState(patient ? patient.name : "");

  // Effect to clear the input field when clearField prop changes
  useEffect(() => {
    if (clearNameField) {
      setInputValue('');
      setOptions([]);
      onChangePatient({});
      setClearNameField(false);
    }
  }, [clearNameField]);


  // user selected a new patient
  function onChange(event, patient, reason) {
    console.log("onChange::patient=", patient, reason);
    if (reason === 'selectOption') {
      setInputValue(patient.name);
      console.log("onChangePatient::", patient);

      fetchPatientData(patient, environment)
        .then(updatedPatient => {
          if (updatedPatient) {
            onChangePatient(updatedPatient);
          }
        })
        .catch(error => {
          console.error("Error fetching patient data:", error);
        });

    }

  }

  // user typed into the box
  function onInputChange(inputValue) {
    setInputValue(inputValue);
  }



  // user hit enter
  function onInputEnter(inputValue) {

    (async () => {

      try {
        if (inputValue.length > 3) {
          setLoading(true);
          console.log('onInputEnter: 1', inputValue);

          /*
          const headers = {"Accept": "* /*, application/json, text/plain"};
          const currentUrl = window.location.href;
          let url = new URL(currentUrl)
          let searchUrl = url.protocol + "//" + url.hostname + ":3001/api/find_hubs?fuzzy="+inputValue;
          const response = await axios.get(searchUrl, headers);
          */

          if (inputValue.toLowerCase().startsWith('patient')) {


            fetchPatientByUid(inputValue, environment)
              .then(hubPatient => {
                if (hubPatient) {
                  if (Object.keys(hubPatient).length > 0) {

                    setOptions([hubPatient]);
                    setLoading(false);
                    setInputValue(hubPatient.name);
                    onChangePatient(hubPatient);
                    setOpen(false);

                    fetchPatientData(hubPatient, environment)
                      .then(updatedPatient => {
                        if (updatedPatient) {
                          onChangePatient(updatedPatient);
                        }
                      })
                      .catch(error => {
                        console.error("Error fetching patient data:", error);
                      });

                  }

                }
              })
              .catch(error => {
                console.error("Error fetching patient data:", error);
              });


          } else {
            const [name, office] = inputValue.split('@').map(s => s.trim());
            const nameQuery = name ? `fts=${encodeURIComponent(name)}` : '';
            const officeQuery = office ? `office_name=${encodeURIComponent(office)}` : '';
            const query = [nameQuery, officeQuery].filter(Boolean).join('&');

            let url = "find_core_patient?env=" + environment;
            if (name && name.length > 2) {
              let fts = name;
              // if name contains only digits and formatting characters like ()- then add the digits only to the url parameter as fts, but prefixed with a space
              if (/^[\d\s()-]+$/.test(name)) {
                //fts = fts + "%20" + name.replace(/[\s()-]/g, '');
                fts = name.replace(/[\s()-]/g, '');
              }
              url = url + "&fts=" + fts;
            }
            if (selectedOrganization?.uid) {
              url = url + "&organization_uid=" + selectedOrganization?.uid;
            }
            if (selectedOffice?.uid) {
              url = url + "&office_uid=" + selectedOffice?.uid;
            }
            url = url + "&status=active";

            const response = await hubsupportalApi.get(url, { cache_timeout: 3600 });

            const patients = response.data.data.items;
            console.log(patients);
            if (response.data.status == "success") {

              /* removed 20250403
              // Extract unique office names
              const uniqueOffices = [...new Set(patients
                .map(p => p.office_name)
                .filter(Boolean))];
              setOfficeOptions(uniqueOffices);
              */

              const patientOptions = patients
                .filter(patient => {
                  // If office is specified, filter patients by office
                  if (selectedOffice && selectedOffice.length > 0) {
                    return patient.office_name && patient.office_name.toLowerCase().includes(selectedOffice.toLowerCase());
                  }
                  if (office) {
                    return patient.office_name && patient.office_name.toLowerCase().includes(office.toLowerCase());
                  }
                  return true; // If no office specified, include all patients
                })
                .map(patient => {
                  const patient_uid = patient.patient_uid || '';
                  const name = patient.extra?.name || '';
                  const surname = patient.extra?.surname || '';
                  const officeName = patient.office_name || '';
                  patient.environment = environment;
                  return {
                    patient_uid: patient_uid,
                    name: `${name} ${surname}`,
                    office: `${officeName}`,
                    data_find: patient,
                    devices: patient.devices,
                    environment: environment,
                  };
                });

              setOptions(patientOptions);
              setLoading(false);
              setOpen(true);
            }


          }


        }
      } catch (e) {
        console.log(e);
      }
    })();

    setInputValue(inputValue);
  }

  useEffect(() => {
    if (!open) setOptions([]);
  }, [open]);


  const handleDoubleClick = () => {
    setSettingsOpen(true);
  };

  const handleSettingsClose = () => {
    setSettingsOpen(false);
  };

  return (
    <>
      <AutoComplete
        onDoubleClick={handleDoubleClick}
        clearOnBlur={false}
        clearOnEscape={false}
        handleHomeEndKeys={false}
        selectOnFocus={false}
        onClear={() => {
          setInputValue('');
          setOptions([]);
          onChangePatient({});
        }}
        filterOptions={(options, state) => {
          if (Array.isArray(options)) {
            return options;
          }
          return [];
        }}
        inputValue={inputValue ? inputValue : ""}
        value={inputValue ? inputValue : ""}
        open={open}
        options={options}
        freeSolo={true} // stop the stupid autocomplete no match error
        isOptionEqualToValue={(option, value) => {
          try {
            return option.name === value;
          } catch (e) { }
        }}
        onChange={(event, value, reason) => {
          try {
            if (reason === 'clear') {
              setInputValue('');
              setOptions([]);
              onChangePatient({});
            }

            //console.log("onChange:event=",event);
            //console.log("onChange:value=",value);
            //console.log("onChange:reason=",reason);
            //event.target.value = event.target.value.toUpperCase();
            onChange(event, value, reason)
          } catch (e) { }
        }}
        onInputChange={(event) => {
          try {
            //console.log("onInputChange:event=",event);
            //console.log("onInputChange:event.target=",event.target);
            //console.log("onInputChange:event.target.value=",event.target.value);
            //event.target.value = event.target.value.toUpperCase();
            //console.log("onInputChange:event.target.value=",event.target.value);
            onInputChange(event.target.value)
          } catch (e) { }
        }}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            //onInputEnter(event.target.value.toUpperCase());
            onInputEnter(event.target.value);
            //setOpen(true);
          }
        }}
        loading={loading}
        id="hubid"
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        getOptionLabel={(option) => option && option.name ? option.name : ""}
        renderOption={(props, option) => (
          <li {...props}>{option.name}&nbsp;@&nbsp;{option.office}</li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            label="Patient"
            autoCapitalize={"characters"}
            InputProps={{
              ...params.InputProps,
              //style: { textTransform: "uppercase" },
              endAdornment: (
                <Fragment>
                  {loading ? <CircularProgress color="inherit" size={32} /> : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              )
            }}
          />
        )}
      />

      <OfficeDialog
        settingsOpen={settingsOpen}
        handleSettingsClose={handleSettingsClose}
        environment={environment}
        setEnvironment={setEnvironment}
        selectedPartner={selectedPartner}
        setSelectedPartner={setSelectedPartner}
        selectedOrganization={selectedOrganization}
        setSelectedOrganization={setSelectedOrganization}
        selectedOffice={selectedOffice}
        setSelectedOffice={setSelectedOffice}
      />
    </>
  );
};

export default PatientSelector;
